const CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || "bnt8fsxy";

const FALLBACK_IMAGE =
  "https://images.unsplash.com/photo-1779675258712-165826aa6969?auto=format&fit=crop&w=1600";

/** Trim accidental spaces from Studio-pasted public IDs. */
export function normalizePublicId(publicId) {
  if (typeof publicId !== "string") return "";
  return publicId.trim();
}

function buildTransforms({ quality = "auto", format = "auto", width, height, crop, startOffset } = {}) {
  const parts = [];
  if (startOffset) parts.push(`so_${startOffset}`);
  parts.push(`f_${format}`, `q_${quality}`);
  if (width) parts.push(`w_${width}`);
  if (height) parts.push(`h_${height}`);
  if (crop) parts.push(`c_${crop}`);
  return parts.join(",");
}

export function cldVideoUrl(publicId, options = {}) {
  const id = normalizePublicId(publicId);
  if (!id) return "";
  if (id.startsWith("http")) return id;
  const transforms = buildTransforms(options);
  return `https://res.cloudinary.com/${CLOUD_NAME}/video/upload/${transforms}/${id}`;
}

export function cldImageUrl(publicId, options = {}) {
  const id = normalizePublicId(publicId);
  if (!id) return "";
  if (id.startsWith("http")) return id;
  const transforms = buildTransforms(options);
  return `https://res.cloudinary.com/${CLOUD_NAME}/image/upload/${transforms}/${id}`;
}

export function cldVideoPoster(publicId, { width = 1600 } = {}) {
  const id = normalizePublicId(publicId);
  if (!id) return "";
  const transforms = buildTransforms({ width, crop: "fill", format: "jpg", quality: "auto" });
  return `https://res.cloudinary.com/${CLOUD_NAME}/video/upload/${transforms}/${id}.jpg`;
}

/** Use cover image when set; otherwise auto-pick a frame from the video. */
export function resolveThumbnailSrc(publicId, cover, videoIds = []) {
  const coverId = normalizePublicId(cover);
  const ids = (videoIds || []).map(normalizePublicId).filter(Boolean);
  if (coverId && !ids.includes(coverId)) {
    return resolveImageSrc(coverId);
  }
  const frameId = normalizePublicId(publicId) || coverId || ids[0];
  if (frameId && ids.includes(frameId)) {
    return resolveImageSrc({ publicId: frameId, videoPoster: true });
  }
  return resolveImageSrc(frameId);
}

export function resolveImageSrc(...sources) {
  for (const source of sources) {
    if (!source) continue;
    if (typeof source === "string") {
      const value = source.trim();
      if (!value) continue;
      if (value.startsWith("http") || value.startsWith("/")) return value;
      return cldImageUrl(value, { width: 1600, crop: "fill" });
    }
    if (source.videoPoster && source.publicId) return cldVideoPoster(source.publicId);
    if (source.publicId) return cldImageUrl(source.publicId, { width: 1600, crop: "fill" });
  }
  return FALLBACK_IMAGE;
}

export function resolveVideoSrc(publicId) {
  return cldVideoUrl(publicId);
}

export { FALLBACK_IMAGE };
